//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
import { v4 as uuidv4 } from "uuid";
export default defineComponent({
  name: "RequestApplicationDetailsTable",
  props: {
    data: {
      type: Array,
      required: true
    },
    selectedProperty: {
      type: Number,
      default: null
    },
    selectedMortgageDetails: {
      type: Number,
      default: null
    },
    columnsClasses: {
      type: Object,
      default: () => ({
        applicantFullName: "w-60",
        property: "w-20 text-center",
        mortgageDetails: "w-20 text-center"
      })
    }
  },
  data() {
    return {
      columns: ["applicantFullName", "property", "mortgageDetails"],
      labelValue1: uuidv4(),
      labelValue2: uuidv4()
    };
  },
  computed: {
    options() {
      return {
        filterable: false,
        sortable: [],
        headings: {
          applicantFullName: this.$tc("global.doorr.applicant", 1),
          personalInformation: this.$t("request-package.requestApplicationDetails.personalInformation"),
          property: this.$t("application-form.property"),
          mortgageDetails: this.$t("application.pages.navigation-tabs.mortgage-details")
        },
        columnsClasses: this.columnsClasses,
        skin: "table mb-0"
      };
    },
    localSelectedProperty: {
      get() {
        return this.selectedProperty;
      },
      set(value) {
        this.$emit("change", value, "selectedProperty");
      }
    },
    localSelectedMortgageDetails: {
      get() {
        return this.selectedMortgageDetails;
      },
      set(value) {
        this.$emit("change", value, "selectedMortgageDetails");
      }
    },
    applicationCustomizationRulesText() {
      return this.$t("request-package.requestApplicationDetails.applicationCustomizationRulesText");
    }
  },
  methods: {
    handleChangeApplicationDetails(value, property) {
      this[property] = value;
    }
  }
});